/* eslint-disable semi */
<template>
  <div class="deviceShow">
    <div class="devname">
      <h2>{{ deviceName }}</h2>
      <h4 v-if="devicetype!=='9'">
        {{ low }}℃-{{ top }}℃
      </h4>
    </div>
    <div v-if="devicetype!=='9'" class="wudu">
      <div class="number">
        <p class="textnumber">
          {{ dataValue }}
        </p>
      </div>
    </div>
    <div v-if="devicetype==='9'">
      <div id="wrapper">
        <div class="tatleh">
          <p>{{ deviceName }}-{{ deviceNuber }}</p>
        </div>
        <div id="termometer">
          <img
            v-show="deviceState === -2"
            class="offlineImg"
            src="http://dhimg.leon056.com/offline.png"
          >

          <div
            id="temperature"
            :class="classObject(deviceState)"
            :style="{height:height+'%'}"
            :data-value="dataValue"
          />
          <div id="graduations" />
        </div>
      </div>
    </div>
    <div class="Chart">
      <div id="myChart" style="width:100%; height: 300px" />
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line semi
import request from '../utils/request.js';
// eslint-disable-next-line semi
import { relativeTime } from '../utils/helpdata.js';
export default {
  name: 'OrderInquery',
  components: {},
  data() {
    return {
      loading: false,
      deviceNuber: '',
      deviceName: '',
      low: '',
      top: '',
      temperature: '',
      devicetype: '9',
      deviceState: 1,
      height: 50,
      dataValue: 37.2,
      option: {
        title: {
          text: '当前设备温变化',
          subtext: relativeTime(new Date())
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '实时温度',
            type: 'line',
            data: [],
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: '平均值' }]
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.GetUrlParam()
    window.setInterval(() => {
      setTimeout(this.onSubmit(), 0)
    }, 60000)
  },
  methods: {
    classObject: function(type) {
      // 正常
      if (type === 0) {
        return 'temperature1'
      } else if (type === 1) {
        return 'temperature2'
      } else if (type === 2) {
        return 'temperature3'
      } else if (type === 3) {
        return 'temperature4'
      } else if (type === -2) {
        return ''
      }
    },
    onSubmit() {
      this.loading = true
      //   this.isShow = true
      request({
        url:
          '/deviceinfoes/detailByDeviceNumber?deviceNumber=' + this.deviceNuber,
        method: 'post'
      }).then(Response => {
        console.log('2222')
        // console.log(Response.data)
        var data = Response.data.data
        console.log(data)
        this.deviceName = data.devicename
        this.low = data.low
        this.top = data.top
        this.dataValue = data.temperature + '°C'
        this.devicetype = data.devicetype
        this.deviceState = data.deviceState
        switch (data.deviceState) {
        // 离线
          case -2:
            this.deviceState = -2
            this.height = 0
            break
            // 正常
          case 0:
            this.deviceState = 0
            this.height = 50
            break
            // 低温
          case 1:
            this.deviceState = 1
            this.height = 25
            break
            // 低烧
          case 2:
            this.deviceState = 2
            this.height = 75
            break
            // 高烧
          case 3:
            this.height = 100
            this.deviceState = 3
            break
        }
        var time1 = relativeTime(new Date())
        var time2 = relativeTime(
          new Date().setTime(new Date().getTime() - 3600 * 1000 * 1)
        )
        request({
          url:
            '/api/getResultByDayRange?deviceNumber=' +
            this.deviceNuber +
            '&dayRangeBegin=' +
            time2 +
            '&dayRangeEnd=' +
            time1 +
            '&timeDuration=5',
          method: 'post'
        }).then(re => {
          const list = re.data.data
          this.option.xAxis.data = []
          this.option.series[0].data = []
          var min = list[0].temperature
          var max = list[0].temperature
          list.forEach(element => {
            if (element.temperature > max) {
              max = element.temperature
            }
            if (element.temperature < min) {
              min = element.temperature
            }
            this.option.xAxis.data.push(element.time.substring(11))
            this.option.series[0].data.push(element.temperature)
          })
          var interval = Number(((max - min) / 6).toFixed(2))
          console.log(max, min, interval)
          if (data.devicetype === '9') {
            console.log('写Y坐标')
            this.option.yAxis.min = min
            this.option.yAxis.max = max
            this.option.yAxis.interval = interval
          }
          console.log(this.option.series[0].data)
          this.drawLine()
          this.loading = false
        })
      })
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      console.log(this.option)
      this.myChart.setOption(this.option)
    },
    // 获取url 参数
    GetUrlParam() {
      var url = document.location.toString()
      var arrObj = url.split('?')
      var arrPara = arrObj[1]
      var arr = arrPara.split('=')
      console.log(arr[1])
      this.deviceNuber = arr[1]
      this.onSubmit()
      //   this.drawLine()
    }
  }
}

</script>

<style   scoped>
.offlineImg {
  width: 60px;
  height: 60px;
  float: left;
  margin-top: 160px;
  margin-left: -20px;
  opacity: 0.4;
}
.Chart{
  margin-top: 20px;
}
body {
  margin: 0 auto;
}
.deviceShow {
  /* background: rgba(224, 235, 237, 0.3); */
  padding: 10px;
  text-align: center;
}
.wudu {
  margin: 0 auto;
  position: relative;
  width: 300px;
  height: 300px;
  border-radius: 150px;
  /* background: linear-gradient(to top, whitesmoke, rgba(19, 206, 102, 0.8)); */
  display: flex;
  justify-content: center;
  align-items: center;
}

.wudu .number {
  position: absolute;
  width: 80%;
  height: 80%;
  border-radius: 50%;
  color: whitesmoke;
  background: linear-gradient(
    to bottom,
    rgba(142, 225, 234, 0.3),
    rgba(105, 225, 238, 0.3),
    rgba(76, 164, 173, 0.3),
    rgba(131, 233, 244, 0.3)
  );
}
.textnumber {
  text-align: center;
  margin-top: 80px;
  font-size: 60px;
}
b {
  font-size: 50px;
}
.devname {
  margin-bottom: -20px;
}
h2,
h4 {
  margin: 0;
  color: #409eff;
}
#wrapper {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#termometer {
  width: 20px;
  height: 182px;
  position: relative;
  border: 9px solid #dcdfe6;
  border-radius: 20px;
  z-index: 1;
  margin-top: 23px;
  box-shadow: darkgrey 10px 10px 30px 10px;
}
#termometer:before,
#termometer:after {
  position: absolute;
  content: "";
  border-radius: 50%;
}

#termometer:after {
  transform: translateX(-50%);
  width: 50px;
  height: 50px;
  background-color: #3dcadf;
  bottom: -41px;
  border: 9px solid #dcdfe6;
  /* margin: 3px; */
  z-index: -3;
  left: 50%;
}
#termometer #graduations {
  height: 59%;
  top: 20%;
  width: 50%;
}
#termometer #graduations,
#termometer #graduations:before {
  position: absolute;
  border-top: 2px solid rgba(0, 0, 0, 0.5);
  border-bottom: 2px solid rgba(0, 0, 0, 0.5);
}
#termometer #graduations:before {
  content: "";
  height: 34%;
  width: 100%;
  top: 32%;
}
#termometer .temperature1,
.temperature2,
.temperature3,
.temperature4 {
  bottom: 0;
  background: linear-gradient(#f56c6c, #e6a23c, #67c23a, #3dcadf) no-repeat
    bottom;
  width: 100%;
  border-radius: 20px;
  background-size: 100% 240px;
  transition: all 0.2s ease-in-out;
}
#termometer .temperature1,
#termometer .temperature1:before,
#termometer .temperature1:after,
#termometer .temperature2,
#termometer .temperature2:before,
#termometer .temperature2:after,
#termometer .temperature3,
#termometer .temperature3:before,
#termometer .temperature3:after,
#termometer .temperature4,
#termometer .temperature4:before,
#termometer .temperature4:after {
  position: absolute;
}
#termometer .temperature1:before {
  content: attr(data-value);
  background: #f2f6fc;
  color: #67c23a;
  z-index: 2;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 1em;
  line-height: 1;
  transform: translateY(50%);
  left: calc(100% + 1em / 1.5);
  top: calc(-1em + 5px - 5px * 2);
}
#termometer .temperature1:after {
  content: "";
  border-top: 0.4545454545em solid transparent;
  border-bottom: 0.4545454545em solid transparent;
  border-right: 0.6666666667em solid #67c23a;
  left: 100%;
  top: calc(-1em / 2.2 + 5px);
}
#termometer .temperature2:before {
  content: attr(data-value);
  background: #f2f6fc;
  color: #3dcadf;
  z-index: 2;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 1em;
  line-height: 1;
  transform: translateY(50%);
  left: calc(100% + 1em / 1.5);
  top: calc(-1em + 5px - 5px * 2);
}
#termometer .temperature2:after {
  content: "";
  border-top: 0.4545454545em solid transparent;
  border-bottom: 0.4545454545em solid transparent;
  border-right: 0.6666666667em solid #3dcadf;
  left: 100%;
  top: calc(-1em / 2.2 + 5px);
}
#termometer .temperature3:before {
  content: attr(data-value);
  background: #f2f6fc;
  color: #e6a23c;
  z-index: 2;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 1em;
  line-height: 1;
  transform: translateY(50%);
  left: calc(100% + 1em / 1.5);
  top: calc(-1em + 5px - 5px * 2);
}
#termometer .temperature3:after {
  content: "";
  border-top: 0.4545454545em solid transparent;
  border-bottom: 0.4545454545em solid transparent;
  border-right: 0.6666666667em solid #e6a23c;
  left: 100%;
  top: calc(-1em / 2.2 + 5px);
}
#termometer .temperature4:before {
  content: attr(data-value);
  background: #f2f6fc;
  color: #f56c6c;
  z-index: 2;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 1em;
  line-height: 1;
  transform: translateY(50%);
  left: calc(100% + 1em / 1.5);
  top: calc(-1em + 5px - 5px * 2);
}
#termometer .temperature4:after {
  content: "";
  border-top: 0.4545454545em solid transparent;
  border-bottom: 0.4545454545em solid transparent;
  border-right: 0.6666666667em solid #f56c6c;
  left: 100%;
  top: calc(-1em / 2.2 + 5px);
}
#termometer .temperature5:before {
  content: attr(data-value);
  background: #f2f6fc;
  color: #303133;
  z-index: 2;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 1em;
  line-height: 1;
  transform: translateY(50%);
  left: calc(100% + 1em / 1.5);
  top: calc(-1em + 5px - 5px * 2);
}
#termometer .temperature5:after {
  content: "";
  border-top: 0.4545454545em solid transparent;
  border-bottom: 0.4545454545em solid transparent;
  border-right: 0.6666666667em solid #303133;
  left: 100%;
  top: calc(-1em / 2.2 + 5px);
}
</style>
